import { render, staticRenderFns } from "./venuedetail.vue?vue&type=template&id=01551bb9&scoped=true&"
import script from "./venuedetail.vue?vue&type=script&lang=js&"
export * from "./venuedetail.vue?vue&type=script&lang=js&"
import style0 from "./venuedetail.vue?vue&type=style&index=0&id=01551bb9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01551bb9",
  null
  
)

component.options.__file = "venuedetail.vue"
export default component.exports